import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'
import { WORKKEYS_RESULTS } from '../../actions/assessments/workkeys'

export default combineReducers({
  results: h2Api.restReducer(WORKKEYS_RESULTS)
})
